import React from "react";

const HubspotIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_705)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 6,
  fill: "url(#paint0_linear_2785_705)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_2785_705)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.6916 19.3524C30.1212 18.3788 29.3073 17.5703 28.3299 17.0064C27.5837 16.5727 26.8122 16.2973 25.941 16.1782V13.0586C26.3634 12.8835 26.7237 12.5857 26.9751 12.2037C27.2266 11.8217 27.3576 11.373 27.3513 10.9158C27.3528 10.6069 27.2933 10.3009 27.1762 10.0151C27.0591 9.72938 26.8867 9.46959 26.6689 9.25068C26.4511 9.03178 26.1921 8.85807 25.907 8.73953C25.6218 8.621 25.3161 8.55999 25.0072 8.55999C24.3817 8.55999 23.7817 8.80793 23.3387 9.2495C22.8957 9.69107 22.6457 10.2903 22.6437 10.9158C22.6437 11.8729 23.1515 12.6894 24.0247 13.0586V16.1606C23.3014 16.2652 22.5996 16.4855 21.9463 16.813L13.5956 10.4899C13.6542 10.2692 13.705 10.0406 13.705 9.80038C13.705 8.35879 12.5369 7.19067 11.0953 7.19067C9.65371 7.19067 8.48755 8.35879 8.48755 9.80038C8.48755 11.242 9.65567 12.4101 11.0973 12.4101C11.5895 12.4101 12.0446 12.2655 12.4373 12.0292L12.9842 12.4433L20.4754 17.8444C20.0789 18.2077 19.7097 18.6218 19.4147 19.0867C18.817 20.0341 18.4517 21.0753 18.4517 22.2121V22.4465C18.4544 23.2175 18.5932 23.982 18.8619 24.7046C19.0885 25.3219 19.4206 25.8845 19.8327 26.3923L17.3441 28.8868C16.6077 28.6133 15.7815 28.795 15.2247 29.3517C14.8458 29.7287 14.6329 30.2424 14.6348 30.7777C14.6368 31.3129 14.8458 31.8227 15.2267 32.2036C15.6076 32.5845 16.1174 32.7955 16.6527 32.7955C17.1879 32.7955 17.7016 32.5845 18.0786 32.2036C18.4556 31.8227 18.6705 31.3129 18.6685 30.7777C18.6684 30.5722 18.6368 30.368 18.5748 30.1721L21.1454 27.6015C21.497 27.8457 21.8779 28.0508 22.2881 28.2266C23.1312 28.5963 24.0417 28.7879 24.9623 28.7891H25.1381C26.2164 28.7891 27.2341 28.5352 28.1893 28.0176C29.1711 27.4911 29.9961 26.714 30.5802 25.7653C31.1799 24.8082 31.5081 23.7475 31.5081 22.5813V22.5227C31.5081 21.3761 31.2424 20.3193 30.6877 19.3504L30.6916 19.3524ZM27.5525 24.7476C26.8551 25.5231 26.0523 26.0017 25.1459 26.0017H24.974C24.4564 26.0017 23.9485 25.8591 23.4543 25.5973C22.9124 25.3155 22.4533 24.8975 22.1221 24.3843C21.7627 23.8764 21.5673 23.3216 21.5673 22.7337V22.5579C21.5673 21.9797 21.6787 21.4308 21.958 20.9131C22.2569 20.3271 22.6612 19.9071 23.1984 19.5575C23.7356 19.2078 24.2884 19.0398 24.9174 19.0398H24.976C25.5425 19.0398 26.0835 19.1512 26.5914 19.411C27.1059 19.6816 27.5429 20.0789 27.8611 20.5654C28.1761 21.0533 28.3709 21.609 28.4296 22.1867L28.4432 22.552C28.4432 23.347 28.1385 24.0835 27.531 24.7515L27.5525 24.7476Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2785_705",
  x1: 40,
  y1: -0.00000238419,
  x2: -0.00000238419,
  y2: 40,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD8B5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2585B"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_705"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_2785_705"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25.6029,
  height: 25.6029,
  fill: "white",
  transform: "translate(7.19849 7.19067)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(HubspotIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;